module.exports = __webpack_public_path__ + "img/icone-play.d6f52382.svg";